export default __webpack_public_path__ + "static/media/storeydb.8bc4394d.png";